import {
  InsuranceDetailsView,
  InsuranceLimitedDetailsView,
} from 'Api/insurance';

/**
 * Check if the given argument is undefined or null
 *
 * @param value {T | undefined | null} value which we want to verify the presence of
 * @returns {boolean} returns whether or not the value is defined
 */
export function isDefined<T>(value: T | undefined | null): value is T {
  return typeof value !== 'undefined' && value !== null;
}

/**
 * Checks if a given value is undefined
 *
 * @param value
 * @returns {boolean} value is undefined
 */
export function isUndefined<T>(value: T | undefined): value is undefined {
  return typeof value === 'undefined';
}

/**
 * Checks if a given value is null
 *
 * @param value
 * @returns {boolean} value is null
 */
export function isNull<T>(value: T | null): value is null {
  return value === null;
}

export const isInsuranceDetailsViewType = (
  value: InsuranceDetailsView | InsuranceLimitedDetailsView,
): value is InsuranceDetailsView => {
  return (
    typeof value === 'object' &&
    'insuranceProduct' in value &&
    value.insuranceProduct !== undefined &&
    'isDeregistered' in value &&
    'coverage' in value
  );
};

export const isEmptyOrUndefined = (
  value: string | undefined,
): value is undefined => value === '' || value === undefined;
